import { Equipment, UpgradeDecoder } from 'src/api/@generated/backend-api';

export const getNumberOfUpgradeUnits = (upgradeDecoder?: UpgradeDecoder) => upgradeDecoder?.upgradableUnits.length ?? 0;

export const hasSeveralUnitsToUpgrade = (equipment: Equipment[]) => equipment.length > 1;

export const isEligibleToUpgrade = (upgradeDecoder: UpgradeDecoder | undefined) => !!upgradeDecoder;
